
import React, { useState, useRef, useEffect } from 'react';
import {
  animationDurationToShowscoresPopup,
  animationDurationToMoveCorrectAnswer
} from "../../../config";
import { useParams } from 'react-router-dom';
import { updateStorage } from "../../../hooks/useStorage";
import { updateGameStorage } from "../../../hooks/useGameStorage";
import RightPart from '../../RightPart';
import LeftPart from './components/LeftPart';
import * as amplitude from '@amplitude/analytics-browser';
import { TopPartNumbers, BottomPartNumbers, getAnswer, getAnswers } from "./Expression.data";
import { useUpdateReduxState } from "../../../hooks/useUpdateReduxState";
import { gameId } from "../../../hooks/getGameId";
import { calcGapY, getCoordinates } from './Expression.data';


export const Multiplication6 = ({ state, handleOpenScore, count, handleUpdateProgress, answerSound, point, level, hint, subscription, onQuestionChange, handleTimerResult }) => {
  const { name, gameName } = useParams();
  const topNumbers = useRef(TopPartNumbers(level));
  const bottomNumbers = useRef(BottomPartNumbers(level));
  const answer = useRef(getAnswer(topNumbers.current, bottomNumbers.current));
  const answers = useRef(getAnswers(answer.current, level));
  const [result, setResult] = useState('+');
  const score = useRef(0);
  const gameCount = useRef(0);
  const [refresh, setRefresh] = useState(false);
  const format = (arr) => arr.join("*");
  const updateState = useUpdateReduxState();
  const [arr, setArr] = useState([])


  useEffect(() => {
    amplitude.track(`${name + "_" + gameName.replace("_", " ") + "_" + level + "_start"}`);
  }, []);

  const checkAnswer = (event, type, val,h) => {
    if (event === 'mouseup') return;

    score.current += type*point[level];
    if (!subscription) {
      updateStorage(type*point[level]);
    }
    if (h) {
      handleTimerResult(false);
      if (arr.length < 2) arr.push(val)
      onQuestionChange?.(`${format(topNumbers.current)}+${format(bottomNumbers.current)}=[${arr}] hint`);
    } else {

      if (type && val === answer.current) {

        setArr(prev => {
          const finalArr = [...prev, val];

          if (prev.length === 0) {
            onQuestionChange?.(`${format(topNumbers.current)}+${format(bottomNumbers.current)}=${val}`);
          } else {
            onQuestionChange?.(
              `${format(topNumbers.current)}+${format(bottomNumbers.current)}=[${finalArr.join(',')}]`
            );
          }

          return finalArr;
        });

        handleTimerResult(true);
      }
      else if (!type && val !== answer.current) {
        setArr(prev => {
          if (prev.length < 2) {
            return [...prev, val];
          }
          return prev;
        });

        return;
      }
      else if (!type && val === answer.current) {
        setArr(prev => {
          onQuestionChange?.(
            `${format(topNumbers.current)}+${format(bottomNumbers.current)}=[${prev.join(',')}]`
          );
          return prev;
        });

        handleTimerResult(false);
      }
    }
    ///!type && setResult(val);
    if (gameCount.current === count - 1) {
      if (subscription) {
        updateState({
          userId: localStorage.getItem('user'),
          profileId: JSON.parse(localStorage.getItem('profile'))?._id,
          game: name,
          score: score.current,
          id: gameId(name, gameName),
          collection: name,
        })
      } else {
        handleUpdateProgress();
        updateGameStorage(name, gameName, type*point[level], true, level);
      }
      setTimeout(() => handleOpenScore(), animationDurationToShowscoresPopup * 1000);
      localStorage.setItem(`${name + '_' + gameName + '_' + level + '_score'}`, score.current);
    } else {
      if (!subscription) {
        handleUpdateProgress();
        updateGameStorage(name, gameName, type*point[level], false, level);
      }

      setTimeout(() => {
        gameCount.current += 1
        topNumbers.current = TopPartNumbers(level);
        bottomNumbers.current = BottomPartNumbers(level);
        answer.current = getAnswer(topNumbers.current, bottomNumbers.current);
        answers.current = getAnswers(answer.current, level);
        setResult('+');
        setArr([])
        setRefresh(!refresh);
      }, animationDurationToMoveCorrectAnswer * 1000);
    }
  }

  return (
    <div className="w-full h-full flex justify-between relative z-30">
      <LeftPart
        topNumbers={topNumbers.current}
        bottomNumbers={bottomNumbers.current}
        state={state}
        result={result}
        level={level}
      />
      <RightPart
        hint={hint}
        state={state}
        answer={answer.current}
        answers={answers.current}
        checkAnswer={checkAnswer}
        answerSound={answerSound}
        getCoordinates={getCoordinates}
        calcGapY={calcGapY}
      />
    </div>
  )
}